import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ufvtqbebc: FaireProductEntity = {
  token: "p_4ufvtqbebc",
  type: "product",
  name: "Coastal Calm® Shower Steamers",
  brandToken: "b_cb27ceb3",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/3e25f86f1f93eb991175791884c19abc203cb00b0aa31cdf206ba529f20fbe33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc841fe632efbb92e5a3fe165c11383b9f98b46079065b1f4ef554470c17a59d.jpeg",
    "https://cdn.faire.com/fastly/bd86f3a33c6a28d321eaf4704f015119c81401e600c6e2c9164af22b10b89d81.jpeg",
    "https://cdn.faire.com/fastly/f3749dd821454a8add0f1f52de1a4bde1d2086bfc4a91b4dcf7e7ed2033ea9f4.jpeg",
    "https://cdn.faire.com/fastly/a240adaadd0b86bfcba3bbd114c0516b7149a6d6bd7e4da6243884980e17212d.jpeg",
    "https://cdn.faire.com/fastly/642fc014984bde9e844e74bae8a398c4db2b7e2fe9ab7868e9a7a0233d2479f9.jpeg",
    "https://cdn.faire.com/fastly/5dda66cf8f61cb1c5130485efa9fe2f0db4da232ba2db15888b5a42e71dae6a4.jpeg",
    "https://cdn.faire.com/fastly/0a2ad3d8e36f5702dc71e240228216c1bbfd6c4900a43c911b0f055aa257f85e.jpeg",
    "https://cdn.faire.com/fastly/a47062642c3f1e923f91c802477c4d9bf3c26a696a372b18aa65cdcb41ec6524.jpeg",
    "https://cdn.faire.com/fastly/3ee5a0c5f10d5745bbf1262fae59f4b7ef1a322ee66a283d8a7f288e08e3a622.jpeg",
    "https://cdn.faire.com/fastly/882b13049cfcb463f82455631ea4a901a1da7e6f768f1445732ff8fe49b628f1.jpeg",
    "https://cdn.faire.com/fastly/71ffaacf998e9e77ec25a8628f2e62d872422d447f9a0ba5ba2125c187ccea0a.jpeg",
  ],
  priceDollars: 8,
  description:
    "Our Coastal Calm® Shower Steamers create a soothing and relaxing experience, creating a spa-like atmosphere in your shower! Simply place a shower steamer on the floor of your shower and let the steam transform your daily shower experience into a luxurious oasis! Handmade in Charleston, SC.\n\nEach box contains 4 individual shower steamers weighing 3oz each.\n\nOur Coastal Calm® fragrance embodies the feeling of a gentle ocean breeze sweeping through wild coastal grass. Fresh, ocean air is blended with the softness of sandalwood and driftwood to create one of our most serene scents. A tranquil or clean, linen scent, and a best seller!\n\nTop: Ocean Breeze, Coastal Grass, Lily\nBase: Driftwood, Amber, Sandalwood\n\nAny Old Whaling Company shower steamer will make a great gift! Our Coastal Calm Shower Steamers are best sellers all year long! These Shower Steamers are a great option for year-round gifts - perfect for hostess gifts, birthday gifts, and baby shower gifts!",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:26.157Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
